/**
 * FormulaDisplay - 物理公式展示组件
 * @description 用于在教程中展示数学公式，支持变量解释
 */

import Phaser from 'phaser';

const COLORS = {
  formulaBg: 0x3a3a5a,
  formulaText: '#4ade80',
  variableText: '#888888',
  border: 0x4a4a6a,
};

/**
 * 公式展示配置
 */
export interface FormulaDisplayConfig {
  /** 公式文本 */
  formula: string;
  /** X 坐标 */
  x: number;
  /** Y 坐标 */
  y: number;
  /** 是否显示背景框 */
  showBackground?: boolean;
}

/**
 * FormulaDisplay 类
 * 展示物理公式的 UI 组件
 */
export class FormulaDisplay {
  private scene: Phaser.Scene;
  private config: FormulaDisplayConfig;

  private formulaBg!: Phaser.GameObjects.Graphics;
  private formulaText!: Phaser.GameObjects.Text;
  private elements: Phaser.GameObjects.GameObject[] = [];

  constructor(scene: Phaser.Scene, config: FormulaDisplayConfig) {
    this.scene = scene;
    this.config = {
      showBackground: true,
      ...config,
    };

    this.createElements();
  }

  private createElements(): void {
    const { formula, x, y, showBackground } = this.config;

    if (showBackground) {
      this.formulaBg = this.scene.add.graphics();
      this.formulaBg.fillStyle(COLORS.formulaBg, 1);
      this.formulaBg.fillRoundedRect(x - 150, y - 20, 300, 40, 4);
      this.formulaBg.lineStyle(1, COLORS.border);
      this.formulaBg.strokeRoundedRect(x - 150, y - 20, 300, 40, 4);
      this.elements.push(this.formulaBg);
    }

    this.formulaText = this.scene.add.text(x, y, formula, {
      fontSize: '18px',
      color: COLORS.formulaText,
      fontFamily: 'Arial',
      fontStyle: 'bold',
    }).setOrigin(0.5);
    this.elements.push(this.formulaText);
  }

  addToContainer(container: Phaser.GameObjects.Container): void {
    this.elements.forEach(el => container.add(el));
  }

  setFormula(formula: string): void {
    this.formulaText.setText(formula);
  }

  destroy(): void {
    this.elements.forEach(el => el.destroy());
  }

  setVisible(visible: boolean): void {
    this.elements.forEach(el => {
      if ('setVisible' in el && typeof el.setVisible === 'function') {
        el.setVisible(visible);
      }
    });
  }
}